import { languages } from "@codeshare/languages";

let untitledCount = 0;

export function nextUntitledName(): string {
  untitledCount += 1;
  return `Untitled-${untitledCount}`;
}

/** Name for a download: the path, or the untitled name plus the language's main extension. */
export function downloadName(name: string, isUntitled: boolean, languageId: string): string {
  if (!isUntitled) return name;
  const extension = languages.get(languageId)?.extensions[0] ?? ".txt";
  return `${name}${extension}`;
}

/** Heuristic: a NUL byte in the first 8 KB means binary (same check git uses). */
export function looksBinary(text: string): boolean {
  return text.slice(0, 8192).includes("\0");
}

export function downloadText(filename: string, text: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
